import React from 'react';
import './CompanyProfile.scss';
import BannerZx from '../BannerZx'
const $ = window.$;
class CompanyProfile extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      bannerImages: [
        { imgPath: require("img/CompanyProfilebg.png"), imgHDPath: `${require("img/CompanyProfilebg.png")} 1x,${require("img/CompanyProfilebg@2x.png")} 2x,${require("img/CompanyProfilebg@3x.png")} 3x`, attachURL: "/" },
      ],
      circlePath: [
        { imgPath: require("img/circle.png"), imgHDPath: `${require("img/circle.png")} 1x,${require("img/circle@2x.png")} 2x,${require("img/circle@3x.png")} 3x`, attachURL: "/" },
      ],
      CompanyProfilemap: [
        { imgPath: require("img/CompanyProfilemap.png"), imgHDPath: `${require("img/CompanyProfilemap.png")} 1x,${require("img/CompanyProfilemap@2x.png")} 2x,${require("img/CompanyProfilemap@3x.png")} 3x`, attachURL: "/" },
      ],
      zheng1_1: [


        {
          imgPath: require("img/工程咨询甲级资信-全专业规划和评估咨询.png"),
          imgHDPath: `${require("img/工程咨询甲级资信-全专业规划和评估咨询.png")} 1x,${require("img/工程咨询甲级资信-全专业规划和评估咨询@2x.png")} 2x,${require("img/工程咨询甲级资信-全专业规划和评估咨询@3x.png")} 3x`,
          title: '工程咨询甲级资信-全专业规划和评估咨询',
          imgsrc: require("img/工程咨询甲级资信-全专业规划和评估咨询@3x.png")
        },

        {
          imgPath: require("img/工程咨询甲级资信-建筑、农林业、电力、电子、石化等.png"),
          imgHDPath: `${require("img/工程咨询甲级资信-建筑、农林业、电力、电子、石化等.png")} 1x,${require("img/工程咨询甲级资信-建筑、农林业、电力、电子、石化等@2x.png")} 2x,${require("img/工程咨询甲级资信-建筑、农林业、电力、电子、石化等@3x.png")} 3x`,
          title: '工程咨询甲级资信-建筑、农林业、电力、电子、石化等',
          imgsrc: require("img/工程咨询甲级资信-建筑、农林业、电力、电子、石化等@3x.png")
        },

        {
          imgPath: require("img/zhengs2-1.png"),
          imgHDPath: `${require("img/zhengs2-1.png")} 1x,${require("img/zhengs2-1@2x.png")} 2x,${require("img/zhengs2-1@3x.png")} 3x`,
          title: '工程设计建筑行业甲级（建筑工程、风景园林工程）',
          imgsrc: require("img/zhengs2-1@3x.png")
        },
        {
          imgPath: require("img/zhengs2-3.png"),
          title: '城乡规划编制乙级',
          imgsrc: require("img/zhengs2-3.png")
        },
        {
          imgPath: require("img/招标代理5A资信.png"),
          imgHDPath: `${require("img/招标代理5A资信.png")} 1x,${require("img/招标代理5A资信@2x.png")} 2x,${require("img/招标代理5A资信@3x.png")} 3x`,
          title: '招标代理5A资信',
          imgsrc: require("img/招标代理5A资信@3x.png")
        },
        {
          imgPath: require("img/工程造价咨询甲级资质.png"),
          imgHDPath: `${require("img/工程造价咨询甲级资质.png")} 1x,${require("img/工程造价咨询甲级资质@2x.png")} 2x,${require("img/工程造价咨询甲级资质@3x.png")} 3x`,
          title: '工程造价咨询甲级资质',
          imgsrc: require("img/工程造价咨询甲级资质@3x.png")
        },
        {
          imgPath: require("img/zheng2-1.png"), imgHDPath: `${require("img/zheng2-1.png")} 1x,${require("img/zheng2-1@2x.png")} 2x,${require("img/zheng2-1@3x.png")} 3x`,
          title: '工程造价咨询企业AAA信用证明',
          imgsrc: require("img/zheng2-1@3x.png")
        },
        {
          imgPath: require("img/zheng2-3.png"), imgHDPath: `${require("img/zheng2-3.png")} 1x,${require("img/zheng2-3@2x.png")} 2x,${require("img/zheng2-3@3x.png")} 3x`,
          title: '中央军委装备价格第三方机构',
          imgsrc: require("img/zheng2-3@3x.png")
        },

        {
          imgPath: require("img/证10拷贝.png"), imgHDPath: `${require("img/证10拷贝.png")} 1x,${require("img/证10拷贝@2x.png")} 2x,${require("img/证10拷贝@3x.png")} 3x`,
          title: '软件企业认证',
          imgsrc: require("img/证10拷贝@3x.png")
        },
        {
          imgPath: require("img/zheng2-2.png"), imgHDPath: `${require("img/zheng2-2.png")} 1x,${require("img/zheng2-2@2x.png")} 2x,${require("img/zheng2-2@3x.png")} 3x`,
          title: '软件产品认证',
          imgsrc: require("img/zheng2-2@3x.png")
        },
        {
          imgPath: require("img/zheng2-4.png"), imgHDPath: `${require("img/zheng2-4.png")} 1x,${require("img/zheng2-4@2x.png")} 2x,${require("img/zheng2-4@3x.png")} 3x`,
          title: 'CMMI3级资质认证',
          imgsrc: require("img/zheng2-4@3x.png")
        },
        {
          imgPath: require("img/zhengs2-0.png"),
          imgHDPath: `${require("img/zhengs2-0.png")} 1x,${require("img/zhengs2-0@2x.png")} 2x,${require("img/zhengs2-0@3x.png")} 3x`,
          title: '工程监理（房屋建筑工程）资质甲级',
          imgsrc: require("img/zhengs2-1@3x.png")
        },
        {
          imgPath: require("img/zheng1-4.png"),
          imgHDPath: `${require("img/zheng1-4.png")} 1x,${require("img/zheng1-4@2x.png")} 2x,${require("img/zheng1-4@3x.png")} 3x`,
          title: '工程监理（市政公用、电力、通信、机电安装工程）资质乙级',
          imgsrc: require("img/zheng1-4@3x.png")
        },



      ],
    }
  }
  componentDidMount() {
    $('.mask').click(function () {
      $(this).css('display', 'none')
    });
  }
  clickFn(event) {
    let imgSrc = event.target.getAttribute("data-img");
    let mask = document.getElementsByClassName('mask')[0];
    mask.innerHTML = ''
    var imgDom = document.createElement("img");
    imgDom.src = imgSrc;
    imgDom.className = 'mask_img'
    mask.appendChild(imgDom);
    mask.style.display = 'block';
  }
  render() {
    return (
      <div className='CompanyProfile'>
        <main className="CompanyProfile-body">
          <BannerZx />
          <div className='CompanyProfile-cost'>
            <p><i></i><span>关于青矩</span></p>
            <p className='cost-txt'>青矩技术股份有限公司（简称“青矩技术”，股票代码：920208.BJ），是国内工程项目管理科技和全过程工程咨询服务领军企业。作为首登中国资本市场的“工程投资管控第一股”，青矩技术率先开启了工程咨询行业“专业+科技+资本”的新发展模式，致力于打造“全过程工程咨询服务产品线”，构建“工程管理科技生态圈”，用科学技术为工程项目管理赋能。“一线一圈”是青矩技术未来业务发展的战略方向。</p>
            <p className='cost-txt'>“全过程工程咨询产品线”，依托青矩技术全资子公司——青矩工程顾问有限公司，以投资决策为起点，以BIM技术为基础，以造价管控为核心，贯穿工程建设的全生命周期，拥有咨询、鉴证、代理等全方位的服务形态。</p>
            <p className='cost-txt'>“工程管理科技生态圈”，依托青矩科技研究院、青矩译筑科技（上海）有限公司、北京百工驿科技有限公司，以ABCD（即AI、BIM、CLOUD、DATA）等新—代信息技术为基础，为工程建设领域提供BIM技术应用与咨询、建设工程大数据平台、智慧造价机器人、信息系统、百工驿平台等科技产品与服务。</p>
            <p className='cost-txt'>青矩技术一直以来深度服务国家建设，项目遍及各个行业和地区。从京沪高铁、北京大兴国际机场、海阳核电站到雄安城市计算中心、小米新能源汽车工厂、国药新冠疫苗生产车间，从南水北调中线工程、神华煤基新材料生产线、国家速滑馆到哈萨克斯坦阿斯塔纳轻轨、印尼哈利达镍铁冶炼生产线、马来西亚森林城市，服务的项目覆盖了城市、交通、能源、工业化和信息化等各个领域的建设与更新，其中既包含传统的基建和房地产项目，也包含新基建、新型城镇化、战略新兴产业投资建设项目。 </p>
            <p className='cost-txt'>青矩技术的“一线一圈”业务战略，在国家“一带一路”、产业升级、乡村振兴及数字中国建设等发展规划中，将迎来新的历史机遇。未来，青矩技术将凭借投资成本管控核心算法与海量数据，赋能国家工程建设；凭借率先登陆中国资本市场的先发优势，努力推动专业、科技与资本的有机融合，整合广阔而分散的工程建设咨询大市场，推动行业向着大而强的目标迈进。</p>
          </div>
          <div className='CompanyProfile-cost CompanyProfile-collaborate'>
            <p><i></i><span>发展历程</span></p>
            <div className='CompanyProfile-collaborate-child'>
              <p className='CompanyProfile-collaborate-line'></p>
              <div className='CompanyProfile-collaborate-list'>
                <em>2023</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>公司成功登陆北交所，成为中国“工程投资管控第一股”</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2021</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>完成在国内各省会、直辖市服务网络的全面布局</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2020</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>入选新三板龙头企业</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2019</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>在马来西亚设立分支机构，公司业务随着“一带一路”走向国际</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2018</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>成功自主研发“青矩小青智慧造价机器人”，开启智慧造价新时代</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2017</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>获得第三十二届北京市企业管理现代化创新成果一等奖</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em></em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>并购“阡陌设计”，提升工程设计实力，打造全过程工程咨询产业链</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2016</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>登录新三板，取得高新技术企业资质，形成“专业、科技、资本”三重驱动的发展模式</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2015</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>开创“青矩互联”与“青矩计量”，引领行业向互联网，人工智能咨询迈进</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em></em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>并购“中辰咨询”，增强工程招标代理业务实力</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2011</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>开始为北京大兴国际机场提供全过程工程咨询服务</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em></em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>首次问鼎全国造价咨询机构营业收入榜首</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2009</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>成为京沪高铁全过程工程咨询服务独家机构</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2005</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>青矩顾问前身——天职（北京）国际工程项目管理有限公司成立</span>
              </div>
              <div className='CompanyProfile-collaborate-list'>
                <em>2001</em>
                <p>
                  {
                    this.state.circlePath.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                    )
                  }
                </p>
                <span>青矩技术股份有限公司创立</span>
              </div>
            </div>
          </div>
          {/* <div className='CompanyProfile-cost CompanyProfile-innter'>
            <p><i></i><span>服务网络</span></p>
            <p className='cost-txt'>青矩总部位于北京，在全国除港澳台地区的所有省会城市及部分非省会中心城市设有分公司，在马来西亚设有境外分支机构，为广大客户提供广泛、统一和贴近的服务。</p>
            {
              this.state.CompanyProfilemap.map((item, index) =>
                <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
              )
            }
          </div> */}
          <div className='CompanyProfile-cost'>
            <p><i></i><span>执业资质</span></p>

            <div className='CompanyProfile-aptitude-box'>
              {
                this.state.zheng1_1.map((item, index) =>
                  <dl key={index}>
                    <dt>
                      <img src={item.imgPath} alt="" onClick={this.clickFn.bind(this)} key={index} srcSet={item.imgHDPath} data-img={item.imgsrc} width="100%" height="100%" />
                    </dt>
                    <dd>{item.title}</dd>
                  </dl>
                )
              }
            </div>
          </div>
        </main>
        <div className="mask">

        </div>
      </div>
    );
  }
}

export default CompanyProfile;
